import React, { Component } from 'react';
import DatePicker, { registerLocale } from "react-datepicker";
import MapCrime from './components/MapCrime';
import es from 'date-fns/locale/es';
import './App.css';
import "react-datepicker/dist/react-datepicker.css";
import murder from './assets/images/murder.svg';
import male from './assets/images/male.svg';
import female from './assets/images/female.svg';
import arrest from './assets/images/arrest.svg';
import robbery from './assets/images/robbery.svg';
import theft from './assets/images/theft.svg';
import gun from './assets/images/gun.svg';
import drugs from './assets/images/drugs.svg';
import knife from './assets/images/knife.svg';
import calendar from './assets/images/calendar.svg';
import clearFilter from './assets/images/clear-filter.svg';

registerLocale('es',es);

const menuItems = [
  {
    id: 0,
    name: 'Homicidios', 
    icon: murder
  },
  {
    'id': 1,  
    name: 'Femicidios', 
    icon: murder
  },
  {
    'id': 2,
    name: 'Detenciones', 
    icon: arrest
  },
  {
    'id': 3,  
    name: 'Robos', 
    icon: robbery 
  },
  {
    'id': 4,  
    name: 'Hurtos', 
    icon: theft 
  },
  {
    'id': 5,  
    name: 'Descomisos de droga', 
    icon: drugs
  },
  {
    'id': 6,  
    name: 'Heridos por bala', 
    icon: gun
  },
  {
    'id': 7,  
    name: 'Heridos por arma blanca', 
    icon: knife 
  }
];

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
        active: '',
        param: '',
        inputCal: false,
        startDate: new Date("2020/01/01"),
        finalDate: new Date()
    }
  };

  handleClick(menuItem) { 
    this.setState({ active: menuItem });

    switch (menuItem) {
      case 'Homicidios': this.setState({param: 'hom'}); break;
      case 'Femicidios': this.setState({param: 'fem'}); break;
      case 'Detenciones': this.setState({param: 'det'}); break;
      case 'Robos': this.setState({param: 'rob'}); break;
      case 'Hurtos': this.setState({param: 'hur'}); break;
      case 'Descomisos de droga': this.setState({param: 'des'}); break;
      case 'Heridos por bala': this.setState({param: 'hba'}); break;
      case 'Heridos por arma blanca': this.setState({param: 'hab'}); break;
      default: break;
    }

  }

  handleShowInputCalendar(){

    this.setState({ inputCal : !this.state.inputCal });

  }

  handleChangeStartDate = date => {

    this.setState({ startDate: date });

  };

  handleChangeFinalDate = date => {

    this.setState({ finalDate: date });
    
  };

  clearFilters = () => {
    this.setState({
      active: '',
      param: '',
      inputCal: false,
      startDate: new Date("2020/01/01"),
      finalDate: new Date()
    })
  }

  render() {
    const active = "active";
    const { inputCal } = this.state;

    return (
      <div className="wrapper d-flex align-items-stretch">
        <nav id="sidebar">
          <div className="custom-menu">
            <button type="button" id="sidebarCollapse" className="btn btn-primary">
                <i className="fa fa-bars"></i>
                <span className="sr-only">Toggle Menu</span>
            </button>
          </div>
          <ul className="list-unstyled components mb-5">
            <li className="title-filter">Filtrar por</li>
          {
            menuItems.map(menuItem => 
                <li 
                    id={menuItem.id}
                    className={this.state.active === menuItem.name ? active : ''} 
                    onClick={this.handleClick.bind(this, menuItem.name)}
                >
                    <a href="#">
                        {/* <span className="fa fa-star mr-3"></span> */}
                        <img src={menuItem.icon} className="menuIcon"/>
                        {/* {menuItem.name === 'Homicidios' ? <img src={male} className="menuIconGenre"/>  : null }
                        {menuItem.name === 'Femicidios' ? <img src={female} className="menuIconGenre"/>  : null } */}
                        {menuItem.name}
                    </a>
                </li>
            )
          }
          <li>
            <a href="#" onClick={() => this.handleShowInputCalendar()}>
              <img src={calendar} className="menuIcon"/>
              <span>Seleccionar fechas</span>
            </a>
          </li>
          {inputCal &&
            <div>
              <div className="inputCalendar">
                <DatePicker
                  locale='es'
                  selected={this.state.startDate}
                  onChange={this.handleChangeStartDate}
                  dateFormat="dd/MM/yyyy"
                  selectsStart
                  startDate={this.state.startDate}
                  endDate={this.state.finalDate}
                  minDate={new Date('2020/01/01')}
                  withPortal
                />
              </div>
              <div className="inputCalendar">
                <DatePicker
                  locale='es'
                  selected={this.state.finalDate}
                  onChange={this.handleChangeFinalDate}
                  dateFormat="dd/MM/yyyy"
                  selectsEnd
                  startDate={this.state.startDate}
                  endDate={this.state.finalDate}
                  minDate={this.state.startDate}
                  maxDate={new Date()}
                  withPortal
                />
              </div>
            </div>
          }
            <li>
              <a href="#" onClick={() => this.clearFilters()}>
                <img src={clearFilter} className="menuIcon"/>
                <span>Reestablecer filtro</span>
              </a>
            </li>
          </ul>
        </nav>
        <div id="content" className="p-4 p-md-5 pt-5">
          <MapCrime param={this.state.param} startDate={this.state.startDate} finalDate={this.state.finalDate}/>
        </div>
      </div>
    )
  }
}

export default App;
